import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { DateCustomFieldFilterControls } from '~/components/Filters/CustomFieldFilter/DateCustomFieldFilterControls';
import { type BaseFilterCardProps, FilterCard } from '~/components/Filters/FilterCard';
import { type CustomFieldFilterType } from '~/components/FiltersMenu/types';
import { clearCustomFieldFilterValuesAction, removeFilterAction } from '~/store/filters/actions';
import { type SelectedFilter } from '~/store/filters/types';

export type DateCustomFieldFilterCardProps = {
  customField: CustomFieldFilterType;
} & BaseFilterCardProps;

export const DateCustomFieldFilterCard = memo(({ customField, ...props }: DateCustomFieldFilterCardProps) => {
  const dispatch = useDispatch();
  const customFieldId = customField.id;

  const handleClearValues = useCallback(() => {
    dispatch(clearCustomFieldFilterValuesAction({ customFieldId }));
  }, [customFieldId, dispatch]);

  const handleRemoveFilter = useCallback(
    (filter: SelectedFilter) => {
      dispatch(removeFilterAction({ filter }));
      handleClearValues();
    },
    [dispatch, handleClearValues],
  );

  return (
    <FilterCard
      currentFilter="customField"
      currentCustomField={customField}
      onClearClick={handleClearValues}
      onRemoveFilter={handleRemoveFilter}
      {...props}
    >
      <DateCustomFieldFilterControls customFieldId={customFieldId} fieldName={customField.name} />
    </FilterCard>
  );
});

DateCustomFieldFilterCard.displayName = 'DateCustomFieldFilterCard';
